let content = [
    {
      id: "general_trading_conditions",
      title: "Condizioni generali di trading",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Dettagli dei prodotti",
          content_before: `<p class="mb-5">
                            iFOREX Europe offre condizioni altamente competitive per i seguenti strumenti finanziari ("Strumenti finanziari" o "Strumenti") (i) negoziazione a margine con leva di strumenti finanziari / attività sottostanti ("Attività sottostanti") tra cui coppie di valute (Forex), materie prime, indici, azioni, ETF e Crypto basati sui CFD ("Strumenti con leva" o "CFD").
                            <br><br>
                            <b>Spread</b><br>Il costo dell'apertura di una posizione è chiamato "Spread". E' la differenza tra il prezzo di vendita (Bid) e il prezzo di acquisto (Ask). Ad esempio, se l'USD/JPY viene quotato ad un prezzo di vendita di 101.202 e un prezzo di acquisto di 101.222, la differenza tra questi due prezzi si chiama spread. In questo caso lo spread è di 2 pips. Se decidi di chiudere un contratto immediatamente dopo l'apertura - e prima che si verifichi qualsiasi movimento dei prezzi - l'importo dello spread sarà detratto dal saldo conto.
                            <br><br>
                            <b>Margine e leva</b><br>Se da un lato il “margine” fa da garanzia per coprire le perdite che potrebbero verificarsi, dall’altro permette di mantenere una posizione molto più elevata rispetto al reale valore dell’account, dando la possibilità di generare profitti alti in rapporto alla cifra investita.
                            <br><br>
                            La leva finanziaria è un’arma a doppio taglio, perché può aumentare in maniera elevata i profitti, ma con la stessa facilità anche amplificare le perdite. Quando si abusa della leva finanziaria, in poco tempo le negoziazioni in perdita possono controbilanciare quelle vincenti. La leva finanziaria nel trading comporta un alto livello di rischio e potrebbe non essere adatta a tutti gli investitori.
                            <br><br>
                            Come titolare di un account iFOREX Europe, accedi al nostro programma Protezione contro saldi negativi, in questo modo non puoi perdere più di quello che hai depositato; nonostante questo, però, un piccolo movimento di mercato può portare a una perdita notevole di fondi. La nostra Piattaforma di trading calcola automaticamente i requisiti di margine prima di eseguire qualsiasi ordine e controlla il livello di fondi disponibili prima che sia fatta qualsiasi richiesta di prelievo fondi.
                            <br><br>
                            I requisiti di margine aumentano quando aumentano i rischi nell’account, come nel momento di apertura/chiusura operazioni o durante una richiesta di prelievo fondi avendo ancora posizioni aperte nel conto.
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Valute</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Materie prime</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indici</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Azioni</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETF</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Cripto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Orari di negoziazione",
          content_before: `<p>
          Durante l'inverno in Europa e Nord America, l'attività settimanale inizia la Domenica alle 22:05 GMT senza interrompersi fino a Venerdì alle 21:00 GMT. Durante l'ora legale in queste regioni, l'attività di mercato settimanale ha inizio la Domenica alle 21:05 GMT e termina il Venerdì alle 20:00. Le ore di attività di mercato possono variare a causa di feste nazionali o a causa di condizioni insolite di liquidità, che possono derivare da eventi globali eccezionali. Gli orari di apertura e chiusura possono essere alterati da iFOREX Europe per motivi di liquidità e di gestione del rischio.
              <br><br>
              Sebbene la maggior parte degli strumenti sono negoziati su una base di 24 ore senza interruzione, alcuni strumenti, tuttavia, hanno speciali orari di negoziazione come mostrato nella tabella seguente:</p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Valute & Cripto",
            2:"Materie Prime",
            3:"Indici",
            4:"Azioni",
            5:"Metals",
            8:"ETF"
          },
          table_titles: [
            "Mercato",
            "Ore di negoziazione (GMT)",
            "1st Intervallo quotidiano (GMT)",
            "2nd Intervallo quotidiano (GMT)",
            "Data valida fino (GMT)"
          ],
          content_after: `<p>Non sei sicuro quale mercato comprende lo strumento che stai cercando? clicca <span class="tclink" target-tab="tc-view-6">qui</span> per vedere la lista degli strumenti per mercato.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Giorni festivi",
          content_before: `<p>
          Per assicurarci che siete a conoscenza di tutte le ore di mercato e dei giorni festivi puoi trovare qui sotto un elenco di eventi che possono cambiare le ore di negoziazione.
            <br>
            Alla iFOREX Europe facciamo del nostro meglio per mantenere queste informazioni aggiornate.
            <br>
            Se desiderate ricevere maggiori informazioni non esitare a contattare il nostro dealing desk.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Mercato",
            "Il trading si ferma alle (GMT)",
            "Il trading riprendende alle (GMT)",
          ],
          content_after: `<p>Non sei sicuro quale mercato comprende lo strumento che stai cercando? clicca <span class="tclink" target-tab="tc-view-6">qui</span> per vedere la lista degli strumenti per mercato.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Ordini ed esecuzione",
          content_before: `<p><b>Tipi di ordine</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>ORDINI DI MERCATO</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Apri posizione</td>
                   <td>Un ordine per aprire una posizione al prezzo corrente disponibile di mercato</td>
                </tr>
                <tr>
                   <td>Chiudi posizione</td>
                   <td>Un ordine per chiudere una posizione al prezzo corrente disponibile di mercato</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>ORDINI LIMITE</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>Lo Stop Loss è un ordine per aprire o chiudere una posizione ad un prezzo inferiore rispetto al prezzo di mercato corrente</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>Il Take Profit è un ordine per aprire o chiudere una posizione ad un prezzo superiore rispetto al prezzo di mercato corrente</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Ordini di mercato</b><br>Gli ordini di mercato (le richieste di transazione, ovvero apertura operazione e chiusura operazione) vengono eseguiti al prezzo presente sulla piattaforma di trading della Società (lato cliente) al momento esatto della esecuzione, a condizione che tale prezzo sia a un livello di tolleranza predeterminato dal prezzo del sottostante aggiornato nel server della Società, anche se il prezzo del sottostante è superiore o inferiore al prezzo aggiornato nella piattaforma di trading (ciò che vedi è ciò che ottieni, o WYSIWYG). Nel caso in cui il prezzo aggiornato nella piattaforma di trading (lato cliente) supera il livello di tolleranza di cui sopra, ad esempio, a causa di movimenti nelle attività sottostanti tra il momento in cui il cliente ha collocato il suo ordine e il momento in cui viene ricevuto ed eseguito, per alta volatilità e la latenza di comunicazione, l'ordine sarà eseguito al prezzo aggiornato nel server della Società che sarà, su base simmetrica, diverso dal prezzo aggiornato nella Piattaforma di Trading (prezzo di mercato). Nel caso di una differenza sostanziale tra il prezzo aggiornato nella (lato cliente) Piattaforma di Trading e il prezzo aggiornato nel server della Società, l'Ordine verrà respinto.
          </p>
          <p>
             <b>Ordini limite</b><br>Gli ordini limite (ordini futuri) vengono eseguiti al prezzo di mercato aggiornato al server della Società che può essere diverso rispetto al prezzo indicato nell'ordine ("Slippage"). Lo slippage può verificarsi nel caso in cui il prezzo indicato nell'ordine non è disponibile nei server, per esempio, a causa della elevata volatilità e gap nei prezzi di mercato. In tal caso, l'ordine sarà eseguito al primo prezzo disponibile indipendentemente dalla direzione dello slippage, sia a favore che a sfavore del cliente, in modo simmetrico e trasparente (Slippage simmetrico).<br><br>Strumenti (ad esempio azioni e indici) non negoziati su una base di 24 ore possono sperimentare un gap di mercato su base giornaliera e sono quindi più suscettibili allo slippage. E 'importante notare che lo slippage non compromette la protezione del saldo conto in negativo e, pertanto, il cliente non potrà mai perdere più dell'importo investito (inclusi i profitti, se presenti), anche se si verifica uno slippage.<br><br>Si prega di notare: Si prega di notare: se il cliente ha impostato un ordine limite sulle proprie transazioni aperte, alcune o tutte queste transazioni possono essere chiuse automaticamente prima di raggiungere i rispettivi ordini limite, a causa del meccanismo obbligatorio di protezione automatica di chiusura automatica. Per ulteriori informazioni sulla protezione obbligatoria per la chiusura automatica del margine, si prega di consultare la scheda "Informazioni sul margine" qui sotto.
          </p>
          <p>
             <b>Ritardo nell'esecuzione</b><br>Un ritardo nell'esecuzione può verificarsi per vari motivi, come ad esempio problemi tecnici di internet del cliente, della rete mobile o di altri tipi di comunicazione verso i server iFOREX Europe, che possono portare a degli "ordini appesi". Un disturbo di connessione a volte può interrompere il segnale e disattivare la piattaforma causando ritardi nella trasmissione dei dati tra la piattaforma del trader ed il server iFOREX Europe.
          </p>
          <p>
             <b>Ordini appesi</b><br>Durante i periodi di forte volume di scambi o di latenza nelle comunicazioni, si possono verificare degli ordini appesi. Questo aumento degli ordini in entrata può talvolta creare delle condizioni in cui vi è un ritardo nella conferma/elaborazione di alcuni Ordini Limite. In alcuni casi la posizione può in effetti essere stata eseguita ed il ritardo è semplicemente nella schermata del cliente a causa del traffico internet consistente.<br><br>Si prega di tener presente che è necessario immettere gli ordini solo una volta. Le immissioni multiple dello stesso ordine potrebbero rallentare, bloccare il computer o inavvertitamente aprire posizioni indesiderate.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Protezione del saldo in negativo",
          content_before: `<p>
          La politica della protezione del saldo in negativo di iFOREX Europe garantisce che le perdite del cliente siano limitate ai fondi investiti nel conto del cliente. Secondo questo criterio, il cliente non dovrà mai affrontare un saldo a debito per perdite causate dal trading operando con iFOREX Europe. La sua potenziale perdita sarà limitata ai fondi depositati nel conto del cliente ed ai fondi guadagnati, ove presenti.</p>`,
          data_id: "",
          content_after: "",
        },
        {
  //id: "margin_information",
  id: "tc-view-24",
  title: "Informazioni di margine",
  content_before: `
    <p>
      La finestra visualizzata di seguito fornisce informazioni dettagliate relative al margine di un conto:
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Patrimonio netto</td>
              <td>€4.995</td>
            </tr>
            <tr>
              <td>Margine utilizzato</td>
              <td>€2.500</td>
            </tr>
            <tr>
              <td>Margine disponibile</td>
              <td>€2.495</td>
            </tr>
            <tr>
              <td>Utilizzo del margine</td>
              <td style="color:green">50,05%</td>
            </tr>
            <tr>
              <td>Margine di mantenimento</td>
              <td>€1.250</td>
            </tr>
            <tr>
              <td>Esposizione netta</td>
              <td>€250.000</td>
            </tr>
            <tr>
              <td>Copertura dell’esposizione</td>
              <td>1,498%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
          <b>Il patrimonio netto</b> riflette il valore in tempo reale del tuo conto. Include il saldo e il profitto/perdita derivante dalle posizioni aperte.
        </li>

        <li>
          <b>Il margine utilizzato</b> mostra l’importo del patrimonio netto in un conto attualmente utilizzato come margine per le operazioni aperte. Se il margine utilizzato è uguale o superiore al patrimonio netto, significa che la leva del conto è massimizzata.
        </li>

        <li>
          <b>Il margine disponibile</b> mostra l’importo del patrimonio netto in un conto che non è attualmente utilizzato ed è disponibile per un ulteriore aumento dell’esposizione netta. Se il margine disponibile è pari a zero, significa che la leva massima del conto è utilizzata.<br>
          Margine disponibile = Patrimonio netto – Margine utilizzato
        </li>

        <li>
          <b>L’utilizzo del margine</b> mostra la percentuale del patrimonio netto utilizzata come margine per le operazioni aperte. Un utilizzo del margine pari o superiore al 100% indica l’uso massimo della leva nel conto.<br>
          Utilizzo del margine % = (Margine utilizzato / Patrimonio netto) x 100
        </li>

        <li>
          <b>Il margine di mantenimento</b> è pari al 50% del margine utilizzato richiesto per mantenere le operazioni aperte. Se il patrimonio netto scende a o sotto questo livello, verrà automaticamente attivata una protezione di chiusura per margine (come definito di seguito).<br>
          Margine di mantenimento = Margine utilizzato x 0,5
        </li>

        <li>
          <b>La copertura dell’esposizione</b> è la percentuale di esposizione coperta dai fondi. Riflette la variazione massima del prezzo di mercato contro la direzione delle operazioni aperte, sostenute dai fondi (fino al raggiungimento del margine di mantenimento).<br>
          Copertura dell’esposizione = (Patrimonio netto – Margine di mantenimento) / Esposizione netta
        </li>
      </ul>

      <b>Protezione di chiusura per margine</b><br>
      Qualora i fondi disponibili nel patrimonio netto di un cliente siano pari o inferiori al margine di mantenimento, iFOREX Europe chiuderà automaticamente l’operazione che consuma il maggiore importo di margine utilizzato, per raggiungere il margine di mantenimento più basso possibile (chiudendo solo le operazioni aperte su strumenti disponibili in quel momento in base agli orari di negoziazione pubblicati). Se non vi sono operazioni aperte su strumenti disponibili in quel momento, verrà chiusa per prima l’operazione sullo strumento che riceve per primo una quotazione. Qualora vi siano più operazioni (più di una) che consumano in egual misura il maggiore margine utilizzato, la Società chiuderà per prima l’operazione aperta più di recente. Nel caso in cui il margine di mantenimento più basso possibile non possa essere raggiunto chiudendo automaticamente una singola operazione, la Società chiuderà tutte le operazioni aperte su uno specifico strumento. iFOREX Europe consente ai clienti di utilizzare completamente i profitti non realizzati delle proprie operazioni aperte per sostenere quelle in perdita.
      <br><br>

      <b><u><u>Esempi</u></u></b><br><br>

      <b>Esempio I</b><br>
      Questo esempio riguarda una situazione in cui un cliente detiene più operazioni aperte e il patrimonio netto del conto raggiunge un livello pari o inferiore al margine di mantenimento:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Operazioni aperte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 operazione EUR/USD: ACQUISTO €60.000 @ tasso 1,1750 (Margine iniziale richiesto = 3,33% x €60.000 = €1.998)</li>
          <li>1 operazione Germany 40: ACQUISTO 4 contratti @ tasso 12.500 (Margine iniziale richiesto = 5% x 4 x €12.500 = €2.500)</li>
          <li>1 operazione WTI Oil: ACQUISTO 500 barili @ tasso 70,00 o 59,56 a barile se il valore è in euro (Margine iniziale richiesto = 10% x 500 x €59,56 = €2.978)</li>
        </ul>
        <li>Margine utilizzato = €1.998 + €2.500 + €2.978 = €7.476</li>
        <li>Livello di margine di mantenimento = €3.738</li>
      </ul>
      Quando il patrimonio netto del conto scende a o sotto €3.738, la protezione di chiusura per margine si attiva chiudendo l’operazione con il maggiore margine utilizzato, ossia l’acquisto di 500 barili di WTI Oil</b>.
      <br><br>

      <b>Esempio II</b><br>
      Questo esempio riguarda una situazione in cui un cliente detiene più operazioni aperte e il patrimonio netto del conto raggiunge un livello pari o inferiore al margine di mantenimento:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Operazioni aperte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 operazioni USD/JPY: ACQUISTO $100.000 (Margine iniziale richiesto = 3,33% x $100.000 = $3.330), VENDITA $80.000 (Margine iniziale richiesto = 3,33% x $80.000 = $2.664)</li>
          <li>1 operazione USD/PLN : VENDITA $80.000 (Margine iniziale richiesto = 5% x $80.000 = $4.000)</li>
        </ul>
        <li>Margine utilizzato = ($3.330 – $2.664) + $4.000 = $4.666</li>
        <li>Livello di margine di mantenimento = $2.333</li>
      </ul>
      Quando il patrimonio netto del conto scende a o sotto $2.333, la protezione di chiusura per margine si attiva chiudendo l’operazione con il maggiore margine utilizzato, ossia la <b>vendita di $80.000 USD/PLN</b>.
      <br><br>
      Nota:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Chiudere la vendita di $80.000 USD/JPY aumenterebbe l’esposizione netta su USD/JPY da $20.000 a $100.000, facendo aumentare il <b>margine utilizzato di $2.664</b> → ($100.000 x 3,33%) - ($20.000 x 3,33%) = $3.330 - $666 = +<u>$2.664</u></li>
        <li>Chiudere l’acquisto di $100.000 USD/JPY aumenterebbe l’esposizione netta su USD/JPY da $20.000 a $80.000, facendo aumentare il <b>margine utilizzato di $1.998</b> → ($80.000 x 3,33%) – ($20.000 x 3,33%) = $2.664 - $666 = +<u>$1.998</u></li>
        <li>Chiudere la vendita di $80.000 USD/PLN ridurrebbe l’esposizione netta su USD/PLN da $80.000 a 0, facendo <b>diminuire il margine utilizzato di $4.000</b></li>
      </ul>

      <b>Esempio III</b><br>
      Questo esempio riguarda una situazione in cui un cliente detiene più operazioni aperte, ma il margine di mantenimento più basso possibile non può essere raggiunto chiudendo automaticamente una singola operazione:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Operazioni aperte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 operazioni USD/JPY: ACQUISTO $100.000 (Margine iniziale richiesto = 3,33% x $100.000 = $3.330), VENDITA $70.000 (Margine iniziale richiesto = 3,33% x $70.000 = $2.331), VENDITA $10.000 (Margine iniziale richiesto = 3,33% x $10.000 = $333)</li>
          <li>2 operazioni USD/PLN: VENDITA $10.000 (Margine iniziale richiesto = 5% x $10.000 = $500), ACQUISTO $8.000 (Margine iniziale richiesto = 5% x $8.000 = $400)</li>
          <li>2 operazioni USD/INR: VENDITA $10.000 (Margine iniziale richiesto = 5% x $10.000 = $500), ACQUISTO $7.000 (Margine iniziale richiesto = 5% x $7.000 = $350)</li>
        </ul>
        <li>Margine utilizzato = ($3.330 – $2.331 – $333) + ($500 - $400) + ($500 - $350) = $916</li>
        <li>Livello di margine di mantenimento = $458</li>
      </ul>
      In questo caso, quando il patrimonio netto scende a o sotto $458, le operazioni nel conto verranno chiuse automaticamente a livello di strumento, in base allo strumento con la maggiore esposizione netta. Pertanto, <b>tutte le operazioni USD/JPY</b> verranno chiuse.
      <br><br>
      Nota:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Chiudere una qualsiasi delle operazioni aumenterebbe l’esposizione netta e quindi il <b>margine utilizzato</b>.</li>
        <li>Chiudere tutte le operazioni USD/JPY ridurrebbe l’esposizione netta di $20.000, facendo diminuire il <b>margine utilizzato di $666</b>, che è maggiore rispetto alla chiusura di operazioni USD/PLN(-$100) o USD/INR (-$150).</li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
},
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Regole di trading aggiuntive",
          content_before: `
              <p>
              <b>Esposizione massimale</b><br>
              A titolo di misura prudenziale volta a una migliore gestione dei rischi per evitare una eccessiva esposizione ad ogni un singolo cliente, iFOREX Europe ha fissato un limite di esposizione netta massima di 12 (dodici) milioni di Euro per cliente. iFOREX Europe ha anche impostato un'esposizione netta massima per ogni strumento. Per visualizzare l'esposizione massima consentita per strumento <span class="tclink" target-tab="tc-view-6" target-section="product_section">clicca qui</span>. iFOREX Europe ha il diritto, a sua esclusiva discrezione, di annullare o modificare tale limitazione in qualsiasi momento senza alcun preavviso.
              <br><br>
              <b>Hedging</b><br>
              L'hedging è per definizione l'apertura di due operazioni sullo stesso strumento finanziario o attività sottostante a diverse direzioni (una in "acquisto" e l'altra in "vendeta"), anche se non allo stesso tempo, ne della stessa quantità. iFOREX Europe considera le operazioni di Hedging ai fini del calcolo del margine minimo su base cumulativa o su base "netta". Inoltre, iFOREX Europe considera la chiusura di una delle operazioni in Hedging come l'apertura di una nuova transazione il cui ammontare è uguale all'importo della transazione rimanente.
              <br><br>
              <b>Compensazione delle transazioni</b><br>
              Nel caso in cui più di una transazione deve essere chiusa simultaneamente in un conto, iFOREX Europe chiuderà tutte le posizioni aperte in massa.<br>Il numero di transazione assegnato ad ogni posizione chiusa viene impostato in base alle regole della FIFO. Questo significa che al momento della chiusura delle posizioni, la prima posizione aperta riceverà il numero più basso di transazione e l'ultima posizione aperta riceverà il più alto numero di transazione.
              <br><br>
              <b>Pratiche di trading non ammesse</b><br>
              iFOREX Europe supporta la lealtà nel trading e non permette pratiche di trading abusive come il lag trading, la manipolazione dei prezzi, del tempo, o qualsiasi altre pratiche illegali e/o utilizzate per avere un vantaggio ingiusto. Esempi di tali pratiche proibite possono essere, ma non limitate a queste, ognuna delle seguenti:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>Scalping:</b> strategia di trading che tenta di sfruttare piccole variazioni di prezzo. I trader che attuano questa strategia aprono molte posizioni a breve termine, chiudendole solitamente nell'arco di secondi o minuti.
                 </li>
                 <li>
                    <b>L' Automazione</b> (ad esempio EA) o negoziazione algoritmica, consiste nell'uso di piattaforme elettroniche per l'immissione di operazioni con un algoritmo che esegue istruzioni pre-programmate di trading le cui variabili possono includere i tempi, il prezzo, la quantità di un ordine o in molti casi l'avvio stesso dell'ordine da parte di un "robot" senza intervento umano.
                 </li>
                 <li>
                    <b>Il trading API</b> è un'interfaccia di programmazione che si associa a tutto il trading che utilizza un programma software per interagire con altri programmi. L'API funge da intermediario tra il trader ed il mercato, inoltrando ordini e recuperando informazioni se necessario.
                 </li>
                 <li>
                    <b>'Account multipli'</b> è il termine che si riferisce a due o più account impostati da un cliente al fine di moltiplicare scorrettamente i benefici relativi agli account offerti da iFOREX Europe.
                 </li>
              </ul>
              <p>Nel caso in cui la Società abbia qualsiasi indicazione o sospetto, a sua esclusiva e assoluta discrezione, di qualsiasi forma di sfruttamento, pratiche di trading illegali, sleali, non autorizzate e/o abusive, utilizzate per dare al Cliente un vantaggio sleale, e/o di frode, manipolazione o violazione degli accordi, delle politiche e dei termini della Società, termini e condizioni della Società, quest'ultima avrà il diritto, a sua esclusiva e assoluta discrezione, e senza derogare ai suoi diritti ai sensi degli accordi con il cliente e della legge applicabile, di annullare e cancellare tutte le transazioni effettuate nei conti in questione, compresi tutti i profitti o le perdite generati e/o bloccare il conto.</p>
              <b>Errori nei prezzi</b><br>
              La tecnologia di trading online non è perfetta e in rari casi l'alimentazione può essere interrotta. Questa eventualità può durare solo per un momento ma quando accade i prezzi spesso possono risentirne. Se si è tentati di effettuare una "operazione di arbitraggio" bisogna tenere a mente che in questa situazione i prezzi non riflettono i prezzi reali di mercato e l'immissione di una operazione può essere distante molti pips dal prezzo visualizzato. Nel caso in cui le operazioni vengano eseguite a prezzi effettivamente non offerti da iFOREX Europe, iFOREX Europe si riserva il diritto di annullare tali operazioni in quanto non considerate valide. Si tenga presente che questi casi di solito sono rari e evitando di tradare in questi momenti, gli investitori possono evitare il rischio associato agli scenari precedentemente esposti.
              <br><br>
              <b>Costo di mantenimento</b><br>
              I conti dei clienti nei quali non è presente attività di trading per un periodo di dodici (12) mesi consecutivi verranno addebitati con un canone trimestrale di manutenzione di 15 dollari americani o con un canone pari all'intero patrimonio netto del conto se questo è inferiore a 15 dollari americani.<br>Se il cliente non ha fondi disponibili sul proprio conto iFOREX Europe non caricherà alcun canone di manutenzione.
              <br><br>
              Per maggiori informazioni sul trading consulta i nostri <a href="/legal/client-agreement.pdf">Termini e condizioni</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Finanziamento overnight",
          content_before: `
                  <p>
                  Quando si trada con leva finanziaria sul Forex CFD con iFOREX Europe, le tue posizioni aperte sono soggette al finanziamento notturno alla fine di ogni giornata di negoziazione. Questo finanziamento notturno può essere soggetto a credito o addebito, calcolato in base ai tassi di interesse delle valute in cui viene negoziato lo strumento sottostante, con l'aggiunta di un mark-up. Il mark-up per le coppie di valute parte dallo 0,75% e può essere più alto e differire tra le posizioni Long (Buy) e Short (Sell). Si prega di consultare la tabella sottostante per i livelli di finanziamento noturno aggiornati.
                  <br><br>
                  Se il calcolo della percentuale del finanziamento notturno è positivo, significa che sarà aggiunto un importo applicabile (accreditato) al saldo del conto. Una percentuale del finanziamento notturno negativa significa che un importo applicabile verrà sottratto (addebitato) al saldo del conto.
                  <br><br>
                  Puoi trovare la relativa percentuale del finanziamento notturno, i relativi importi e i relativi tempi di esecuzione sui moduli delle posizioni e dei limiti, sotto gli Strumenti, nella scheda "Informazioni di mercato". Per calcolare il Finanziamento notturno, con il quale il tuo conto sarà addebitato o accreditato, semplicemente moltiplica la percentuale del finanziamento notturno con l'ammontare della tua posizione. I dettagli del processo di finanziamento Overnight per ogni CFD lo trovi su ''Informazioni strumento'' in ''Overnight Financing (GMT)''. Il valore e la percentuale del finanziamento Overnight di un determinato strumento vieni applicato per un giorno. I CFD negoziati 5 giorni alla settimana verranno accreditati o addebitati con un valore pari a 3 volte il valore visualizzato durante l' ultimo giorno della settimana di negoziazione degli asset sottostanti , in quanto copre l' intero periodo del weekend. L importo del finanziamento Overnight e' quotato in base alla valuta del CFD. Tuttavia se la valuta del CFD quotata si discosta dalla valuta del tuo conto, verra' convertita in base alla valuta del tuo conto.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Calcolo della percentuale del finanziamento notturno in acquisto (posizioni lunghe):
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Tasso di interesse dell'altra valuta - Tasso di interesse della valuta di base + Margine lungo</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Calcolo della percentuale del finanziamento notturno in vendita (posizioni corte):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Tasso di interesse dell'altra valuta - Tasso di interesse della valuta di base - Margine corto</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Per calcolare l'importo del finanziamento notturno, semplicemente moltiplica la percentuale per l'importo della posizione:<br><br>Importo del finanziamento notturno = Importo della posizone X Percentuale del finanziamento notturno
                      <br><br><br>
                      <u><b><u>Esempi</u></b></u><br><br>
                      <b>Esempio I</b><br><br>
                      Questo esempio comporta una situazione in cui la differenza del tasso interbancario sia SUPERIORE a quella del markup. In questi casi, il tuo conto verrà addebitato andando in acquisto e accreditato andando in vendita:
                      <br><br>
                      <ul class="list-style-dashed mb-4">
                          <li>Strumento = EUR/TRY EUR/USD (Euro vs. US Dollar)</li>
                          <li>Tasso di interesse EUR (valuta di base) (annualizzato) = -0,37% = -0,0037</li>
                          <li>Tasso di interesse USD (altra valuta) (annualizzato) = 1,08% = 0,0108</li>
                          <li>Differenza dei tassi interbancari = 1,45% = 0,0145</li>
                          <li>Long Markup = 0.75% = 0.0075</li>
                          <li>Short Markup = 0.75% = 0.0075</li>
                          <li>Valore dell'importo della posizione espresso nell'altra valuta = 106,550 USD (100,000 EUR al tasso attuale di 1.0655)</li>
                      </ul>
                      Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Importo del finanziamento notturno = 106,550 × (-0.0000611) = -6.51 USD, il che significa 6.51 USD di carico al giorno
                    <br><br><br>
                    Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Importo del finanziamento notturno = 106.550 X 00,001944 = 2.07 USD di credito al giorno
                    <br><br><br>
                    <b>Esempio II</b><br><br>
                    Questo esempio comporta una situazione in cui la differenza del tasso interbancario sia SUPERIORE a quella del markup e i markup Long e Short sono diversi. In questi casi, Il tuo conto verrà addebitato ogni notte indipendentemente dalla direzione delle tue posizioni:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Strumento = EUR/TRY (Euro vs. Lira turca)</li>
                       <li>Tasso di interesse EUR (valuta di base) (annualizzato) = -0,37% = -0,0037</li>
                       <li>Tasso di interesse TRY (altra valuta) (annualizzato) = 22,75% = 0,2275</li>
                       <li>Differenza dei tassi interbancari = 23.12% = 0.2312</li>
                       <li>Long Markup = 0.75% = 0.0075</li>
                       <li>Short Markup = 14.00% = 0.14</li>
                       <li>Valore dell'importo della posizione espresso nell'altra valuta = 620,000 TRY (100,000 EUR al tasso attuale di 6.2000)</li>
                    </ul>
                    Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Percentuale del finanziamento notturno</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Importo del finanziamento notturno = 620,000 × (-0.000663) = -411 TRY, il che significa 411 TRY di carico al giorno (≅80 USD)
                        <br><br><br>
                        Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Percentuale del finanziamento notturno</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Importo del finanziamento notturno = 620.000 X 0.000253 = 157 TRY, ovvero 157 TRY di credito al giorno (≅30 USD)
                        <br><br><br>
                        <b>Esempio III</b><br><br>
                        Questo esempio comporta una situazione in cui la differenza del tasso interbancario sia INFERIORE al markup negativo. In questi casi, il tuo conto verrà addebitato andando in vendita e accreditato andando in acquisto:
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Strumento = USD/JPY (US Dollar contro Yen Giapponise)</li>
                           <li>Tasso di interesse USD (valuta di base) (annualizzato) = 1,08% = 1,08</li>
                           <li>Tasso di interesse JPY (altra valuta) (annualizzato) = -0,09% = -0,0009</li>
                           <li>Differenza dei tassi interbancari = -1,17% = -0,0117</li>
                           <li>Long Markup = 0.75% = 0.0075</li>
                           <li>Short Markup = 0.75% = 0.0075</li>
                           <li>Valore dell'importo della posizione espresso nell'altra valuta = 10,341,000 JPY (100,000 USD al tasso attuale di 103.41)</li>
                        </ul>
                        Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Percentuale del finanziamento notturno</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Importo del finanziamento notturno = 10,341,000 × 0.00001167 = 120.65 JPY di credito al giorno (≅1.1 USD)
                        <br><br><br>
                        Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Percentuale del finanziamento notturno</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Importo del finanziamento notturno = 10,341,000 ×(-0.0000533) = -551.52 JPY, il che significa 551.52 JPY di carico al giorno (≅5.3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* I rpagamenti del finanziamento notturno possono richiedere fino a 15 minuti per l'elaborazione alla fine della giornata di negoziazione, dopo di che il vostro conto sarà accreditato o addebitato in modo appropriato.</p>`,
          table_titles: [
            "Strumento",
            "Percentulae giornaliera del finanziamento notturno (Vendita)",
            "Percentulae giornaliera del finanziamento notturno (Acquisto)",
            "Finanziamento notturno (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Indici, Materie Prime, Criptovalute in CFD",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Finanziamento overnight",
          content_before: `
              <p>
              Quando tradi con iFOREX Europe con i CFD su indici e materie prime e criptovalute, le tue operazioni aperte sono soggette a un Finanziamento overnight alla fine di ogni giorno di negoziazione. Questo Finanziamento overnight può essere soggetto a credito o debito, calcolato sulla base dei tassi d'interesse rilevanti per le valute in cui lo strumento sottostante è negoziato, più un mark-up. Il mark-up per le criptovalute può essere significativamente più alto a causa delle condizioni estreme del mercato delle criptovalute. Si prega di rivedere la tabella sottostante per gli ultimi livelli di finanziamento Overnight.
              <br><br>
              Se il calcolo della percentuale del finanziamento notturno è positivo, significa che sarà aggiunto un importo applicabile (accreditato) al saldo del conto. Una percentuale del finanziamento notturno negativa significa che un importo applicabile verrà sottratto (addebitato) al saldo del conto.
              <br><br>
              Puoi trovare la relativa percentuale del finanziamento notturno, i relativi importi e i relativi tempi di esecuzione sui moduli delle posizioni e dei limiti, sotto gli Strumenti, nella scheda "Informazioni di mercato". Per calcolare il Finanziamento notturno, con il quale il tuo conto sarà addebitato o accreditato, semplicemente moltiplica la percentuale del finanziamento notturno con l'ammontare della tua posizione. I dettagli del processo di finanziamento Overnight per ogni CFD lo trovi su ''Informazioni strumento'' in ''Overnight Financing (GMT)''. Il valore e la percentuale del finanziamento Overnight di un determinato strumento vieni applicato per un giorno. I CFD negoziati 5 giorni alla settimana verranno accreditati o addebitati con un valore pari a 3 volte il valore visualizzato durante l' ultimo giorno della settimana di negoziazione degli asset sottostanti , in quanto copre l' intero periodo del weekend. L importo del finanziamento Overnight e' quotato in base alla valuta del CFD. Tuttavia se la valuta del CFD quotata si discosta dalla valuta del tuo conto, verra' convertita in base alla valuta del tuo conto.
              <br><br>
              <u><b><u>Formula</u></b></u><br><br>
              Calcolo della percentuale del finanziamento notturno in acquisto (posizioni lunghe):
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Tasso di interesse + Margine</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Calcolo della percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Tasso di interesse - Margine</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Per calcolare l'importo del finanziamento notturno, semplicemente moltiplica la percentuale per l'importo della posizione:<br><br>Importo del finanziamento notturno = Importo della posizone X Percentuale del finanziamento notturno
                <br><br><br>
                <u><b><u>Esempi</u></b></u><br><br>
                <b>Esempio I</b><br><br>
                Questo esempio comporta una situazione in cui il tasso interbancario sia SUPERIORE a quella del markup. In questi casi, il tuo conto verrà addebitato andando in acquisto e accreditato andando in vendita:
                <br><br>
                <ul class="list-style-dashed">
                   <li>Strumento = Brazil Ibovespa</li>
                   <li>Tasso di interesse Real Brasiliano (BRL) (annualizzato) = 9,567% = 0,09567</li>
                   <li>Markup = 2.5% = 0.025</li>
                   <li>Valore dell'importo della posizione espresso in valuta = 127.380 BRL (2 contratti dell'Indice alla chiusura attuale al tasso di 63690 BRL per contratto)</li>
                </ul>
                <br>
                Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Importo del finanziamento notturno = 127,380 × (-0.0003351944) = -42.70 BRL, il che significa 42.70 BRL di carico al giorno (≅13.58 USD)
                <br><br><br>
                Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Importo del finanziamento notturno = 127,380 × 0.00019630556 = 25 BRL di credito al giorno (≅7.95 USD)
                <br><br><br>
                <b>Esempio II</b><br><br>
                Questo esempio comporta una situazione in cui il tasso interbancario sia INFERIORE a quella del markup. In questi casi, Il tuo conto verrà addebitato ogni notte indipendentemente dalla direzione delle tue posizioni:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Strumento = Oil (Crude Light WTI)</li>
                   <li>Tasso di interesse Dollaro Statunitense (USD) (annualizzato) = 1,08% = 0,0108</li>
                   <li>Markup = 2.5% = 0.025</li>
                   <li>Valore dell'importo della posizione espresso in denaro = 53,250 USD (1,000 barili di petrolio alla chiusura attuale al tasso di 53.25 USD per barile)</li>
                </ul>

                Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Importo del finanziamento notturno = 53,250 × (-0.00009944) = -5.30 USD, il che significa 5.30 USD di carico al giorno
                    <br><br><br>
                    Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Percentuale del finanziamento notturno</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Importo del finanziamento notturno = 53,250 × (-0.00003944) = -2.10 USD, il che significa 2.10 USD di carico al giorno
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* I rpagamenti del finanziamento notturno possono richiedere fino a 15 minuti per l'elaborazione alla fine della giornata di negoziazione, dopo di che il vostro conto sarà accreditato o addebitato in modo appropriato.</p>`,
          table_titles: [
            "Strumento",
            "Percentulae giornaliera del finanziamento notturno (Vendita)",
            "Percentulae giornaliera del finanziamento notturno (Acquisto)",
            "Finanziamento notturno (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Date di Rollover dei Contratti",
          content_before: `<p>
          Ogni CFD che si basa su un contratto future (ad esempio materie prime ed indici) ha una data di rollover.
          <br><br>
          Una volta raggiunta la data di rollover dello strumento in questione, tutte le posizioni aperte del contratto CFD future subiranno il rollover e saranno trasferite nel contratto seguente, in modo da rimanere aperte con il nuovo contratto future.
          <br><br>
          Una volta effettuato il rollover, il P/L (Profitto/perdita) della posizione aperta mostrerà la differenza di prezzo tra i prezzi dei contratti nuovi e scaduti, nonché includere lo spread del mark-up. Tutti i livelli degli ordini limite associati vengono automaticamente adeguati in base al nuovo prezzo contrattuale del future.
          <br><br>
          Ad esempio, se l'ultimo prezzo del contratto WTI Oil di febbraio è di $ 50.125 e il prezzo di mercato del seguente contratto (marzo) in quel momento è di $ 50.805, allora il livello dei prezzi di tutti gli ordini limite in sospeso sarà aggiornato verso l'alto di $ 0.68.
          <br><br>
          Le date di rollover dei contratti dipendono dallo strumento che si sta negoziando, e quelle di cui qui di seguito devono essere le uniche date di rollover applicabili sui CFD di iFOREX Europe:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Contratto Mensile", "Data e ora di rinnovo del contratto (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Materie prime", "Indici"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Titoli azionari e ETF in CFD",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Finanziamento overnight",
          content_before: `<p>
          Quando tradate con iFOREX Europe sui CFD sulle azioni e ETF , le vostre operazioni aperte sono soggette a un Finanziamento Overnight alla fine di ogni giorno di negoziazione. Questo Finanziamento overnight può essere soggetto a credito o debito, calcolato sulla base dei tassi d'interesse rilevanti per le valute in cui lo strumento sottostante è negoziato, più un mark-up. Si prega di rivedere la tabella sottostante per gli ultimi livelli di finanziamento Overnight.
          <br><br>
          Se il calcolo della percentuale del finanziamento notturno è positivo, significa che sarà aggiunto un importo applicabile (accreditato) al saldo del conto. Una percentuale del finanziamento notturno negativa significa che un importo applicabile verrà sottratto (addebitato) al saldo del conto.
          <br><br>
          Puoi trovare la relativa percentuale del finanziamento notturno, i relativi importi e i relativi tempi di esecuzione sui moduli delle posizioni e dei limiti, sotto gli Strumenti, nella scheda "Informazioni di mercato". Per calcolare il Finanziamento notturno, con il quale il tuo conto sarà addebitato o accreditato, semplicemente moltiplica la percentuale del finanziamento notturno con l'ammontare della tua posizione. I dettagli del processo di finanziamento Overnight per ogni CFD lo trovi su ''Informazioni strumento'' in ''Overnight Financing (GMT)''. Il valore e la percentuale del finanziamento Overnight di un determinato strumento vieni applicato per un giorno. I CFD negoziati 5 giorni alla settimana verranno accreditati o addebitati con un valore pari a 3 volte il valore visualizzato durante l' ultimo giorno della settimana di negoziazione degli asset sottostanti , in quanto copre l' intero periodo del weekend. L importo del finanziamento Overnight e' quotato in base alla valuta del CFD. Tuttavia se la valuta del CFD quotata si discosta dalla valuta del tuo conto , verra' convertita in base alla valuta del tuo conto.
          <br><br>
          <u><b><u>Formula</u></b></u><br><br>
          Calcolo della percentuale del finanziamento notturno in acquisto (posizioni lunghe):
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Tasso di interesse + Margine</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Calcolo della percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Tasso di interesse - Margine</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Per calcolare l'importo del finanziamento notturno, semplicemente moltiplica la percentuale per l'importo della posizione:<br><br>Importo del finanziamento notturno = Importo della posizone X Percentuale del finanziamento notturno
                <br><br><br>
                <u><b><u>Esempi</u></b></u><br><br>
                <b>Esempio I</b><br><br>
                Questo esempio comporta una situazione in cui il tasso interbancario sia SUPERIORE a quella del markup. In questi casi, il tuo conto verrà addebitato andando in acquisto e accreditato andando in vendita:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Strumento = Gazprom (GAZP)</li>
                   <li>Tasso di interesse Rublo Russo (RUB) (annualizzato) = 9,5% = 0,095</li>
                   <li>Markup = 5% = 0.05</li>
                   <li>Valore dell'importo della posizione espresso in valuta = 2,459,000 RUB (20,000 azioni alla chiusura attuale al tasso di 122.95 RUB per azione)</li>
                </ul>

                Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Importo del finanziamento notturno = 2,459,000 × (-0.0004) = -983.60 RUB, il che significa 983.60 RUB di carico al giorno (≅17.52 USD)
                <br><br><br>
                Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Importo del finanziamento notturno = 2,459,000 × 0.000125 = 307.38 RUB di credito al giorno (≅5.48 USD)
                <br><br><br>
                <b>Esempio II</b><br><br>
                Questo esempio comporta una situazione in cui il tasso interbancario sia INFERIORE a quella del markup. In questi casi, Il tuo conto verrà addebitato ogni notte indipendentemente dalla direzione delle tue posizioni:
                <br><br>
                <ul class="list-style-dashed">
                    <li>Strumento = Apple (AAPL)</li>
                    <li>Tasso di interesse Dollaro Statunitense (USD) (annualizzato) = 1,08% = 0,0108</li>
                    <li>Markup = 5% = 0.05</li>
                    <li>Valore dell'importo della posizione espresso in denaro = 70,600 USD (500 azioni alla chiusura attuale al tasso di 141.20 USD per azione)</li>
                </ul>
                <br>
                Percentuale del finanziamento notturno in acquisto (posizioni lunghe):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Importo del finanziamento notturno = 70,600 × = (-0.000169) -11.93 USD, il che significa 11.93 USD di carico al giorno
                <br><br><br>
                Percentuale del finanziamento notturno in vendita (posizioni corte):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Percentuale del finanziamento notturno</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                Importo del finanziamento notturno = 70,600 × (-0.000109) = -7.70 USD, il che significa 7.70 USD di carico al giorno
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* I rpagamenti del finanziamento notturno possono richiedere fino a 15 minuti per l'elaborazione alla fine della giornata di negoziazione, dopo di che il vostro conto sarà accreditato o addebitato in modo appropriato.</p>`,
          table_titles: [
            "Strumento",
            "Percentulae giornaliera del finanziamento notturno (Vendita)",
            "Percentulae giornaliera del finanziamento notturno (Acquisto)",
            "Finanziamento notturno (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dividendi",
          content_before: `<p>
                      In caso di distribuzione di dividendi in contanti in relazione ad un'azione CFD, un adeguamento del dividendo sarà effettuato al saldo del Cliente in rispetto delle posizioni della quota detenuta dal Cliente alla fine del giorno lavorativo che precede la data di stacco della cedola. La regolazione del dividendo sarà calcolata in base alla dimensione del dividendo, alla dimensione della posizione del cliente e in base al fatto che si tratti di una transazione in acquisto o in vendita, per cui in caso di posizioni lunghe l'aggiustamento dovrà essere accreditato al saldo del Cliente, mentre in caso di posizioni corte l'aggiustamento sarà addebitato al saldo del Cliente. I dividendi sono accreditati o addebitati al saldo del Cliente fuori degli orari di negoziazione e prima dell'apertura del giorno di negoziazione successivo dell'azione, e sono subordinati al fine che il Cliente mantenga la sua rispettiva posizione al momento della regolazione del dividendo. Durante questo periodo, al fine di mantenere il fair value del patrimonio netto del Cliente fino all'apertura del giorno di negoziazione successivo, la Società dovrà regolare la posizione del cliente in conformità con l'importo del dividendo addebitato o accreditato dal saldo del Cliente.
                      <br><br>
                      <u><u>Esempio</u>:</u><br>
                      Coca-Cola emette un dividendo di $0,35 per azione.<br>
                      La data di stacco della cedola è il 29 Novembre e quella di regolamento in iFOREX Europe è il 28 Novembre alle 22:05 GMT.<br>
                      Il prezzo di chiusura prima del regolamento è di 41.65.<br>
                      Un cliente che detiene una posizione lunga di 5000 azioni sarà accreditato con 0,35 x 5000 = 1.750 USD se il suo contratto verrà aperto alla data di regolamento.
                      <br>
                      Un importo analogo verrà addebitato al saldo di un cliente che detiene una posizione corta.
                      <br>
                      Il prezzo delle azioni sarà regolato durante gli afterhours da 41.65 a 41.30, che sarà uguale all'ultimo prezzo dell'azione meno l'importo del dividendo.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Al momento non ci sono informazioni sui prossimi dividendi.",
          table_titles: [
            "Azione / ETF",
            "Mercato",
            "Importo dividendo",
            "Data e ora (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Dividendi azionari, frazionamenti azionari e altre azioni societarie",
          content_before: `<p>
          Le azioni sul capitale sono alcuni eventi che hanno effetto sul valore delle azioni di una società pubblica. Se non diversamente indicato di seguito in relazione a specifiche Azioni Societarie , al verificarsi di una azione sul capitale in una azione specifica, iFOREX Europe liquida qualsiasi posizione aperta e rimuove qualsiasi ordine limite del CFD dell'azione specifica del(i) CFD pertinente(i) compresa, se necessario, la rimozione di qualsiasi ordine limite di tale(i) CFD.
          <br><br>
          Le azioni sul capitale in iFOREX Europe comprendono la distribuzione dei dividendi, il consolidamento e qualsiasi altro evento che incide o può incidere materialmente sul prezzo dell'azione (comprese le comunicazioni aziendali, acquisizioni, fusioni, insolvenze, ecc).
          <br><br>

          <b>Dividendi azionari</b><br>

            I dividendi azionari in borsa non modificano il valore complessivo delle azioni per chi le detiene, ma cambiano il numero di azioni e il loro prezzo.<br>
            Riceverai il “fattore di aggiustamento” per ogni azione posseduta.<br>
            Qualsiasi delle tue operazioni aperte e/o ordini limite durante la data e l'orario del dividendo azionario avrà la quantità, il prezzo e i limiti associati adeguati di conseguenza (incluso il saldo del conto a causa degli adeguamenti richiesti di P/L, se applicabile).<br>
            Ad esempio, in un aggiustamento azionario con un fattore di aggiustamento di 1,8, 1 azione diventa 1,8 azioni dopo l'evento e il prezzo viene diviso per 1,8, lasciando invariato il valore complessivo delle azioni.<br>
            Es.: 1 azione dal prezzo di $1.000 diventerà 1,8 azioni dal prezzo di $555,56 dopo l'evento: 1×$1.000 = 1,8×$555,56 = $1.000 valore.<br><br>


          <strong>
          Regole specifiche per i frazionamenti azionari e i frazionamenti azionari negativi
          </strong>
          <br>
          I frazionamenti azionari e i frazionamenti inversi in borsa non alterano il valore totale delle azioni per chi le detiene, ma modificano il numero di azioni e il loro prezzo. Questi frazionamenti vengono solitamente effettuati quando il prezzo delle azioni è troppo alto o troppo basso. Se un'operazione/limite aperto si scontra con un frazionamento azionario, il suo importo, il tasso e il livello del limite associato verranno adeguati di conseguenza (compreso il saldo del conto, a causa degli aggiustamenti PL richiesti, se applicabili).
          <br><br>
          Ad esempio, in un frazionamento 1:10, 1 azione diventa 10 azioni dopo l'evento e il prezzo viene diviso per 10, lasciando invariato il valore complessivo delle azioni. Ad esempio, 1 azione al prezzo di 1.000 dollari diventerà 10 azioni al prezzo di 100 dollari dopo l'evento: 1x $1.000 = 10 x$100 = valore di $1.000.
          <br><br>
          Di seguito è riportato l'elenco delle prossime azioni societarie:
              </p>`,
          data_id: "CorporateActions",
          no_information:"Qui al momento non ci sono ancora informazioni sulle Corporate Actions future",
          content_after: "",
          table_titles: ["Azione / ETF", "Mercato", "Type", "Data e ora (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Report Utili",
          content_before: `<p> 
                                Un rapporto sugli utili è un processo di presentazione periodica, da parte delle aziende private, per comunicare le loro performance. Analizzando le relazioni trimestrali sugli utili, gli investitori possono analizzare la salute finanziaria dell'azienda. L'annuncio degli utili per una società, in particolare per una società popolare con una capitalizzazione di mercato elevata, può influenzare i prezzi delle sue azioni, il che può causare ampie fluttuazioni nei giorni in cui tali report trimestrali vengono pubblicati.
                                <br><br>
                                Per questo motivo, l'esposizione massima realativa alle azioni in questione sarà ridotta a 10.000 Dollari Americani, per tutto il periodo della pubblicazione.
                            </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  